/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useState } from "react";
import { THistoricoProjeto, TNotaHistorico, TPedidoHistorico, TProjetoHistorico } from "../../types";
import { Typography, useMediaQuery } from "@mui/material";
import { FilterButton, OptionButton } from "src/components/componentes/FilterButton";
import api, { IDataRequest, STATUS_CODE } from "src/framework/providers/api";
import { CardHistoricoNovo } from "./TabelaComparacaoProjetos/CardHistoricoNovo";
import { componentes$, getCidades, getEstruturasDistribuicao } from "src/store/global.store";
import { useHistory } from "react-router-dom";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import TabelaComparacaoProjetos from "./TabelaComparacaoProjetos";
import { FIELDS_DESCONTOS, FIELDS_NOTAS, FIELDS_PROJETO, FIELDS_PEDIDOS } from "../../constants";
import TabelaComparacaoPedidos from "./TabelaComparacaoPedidos";
import { useObservable } from "src/framework/store/storeUtil";
import TabelaComparacaoDescontos from "./TabelaComparacaoDescontos";
import TabelaComparacaoNotasFiscais from "./TabelaComparacaoNotasFiscais";
import moment from "moment";
import { arrayEquals, arraySort } from "../HistoricoMigrado/utils/actions";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import { CargasPrioritariasDom, ProjetosEquipamentosDom } from "./TabelaComparacaoProjetos/types";
import theme from "src/theme/light";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ID_INVERSOR, ID_INVERSOR_HIBRIDO, ID_MICROINVERSOR, inversoresMap, LISTA_INVERSOR_OFFGRID } from "src/components/componentes/types";

export interface IHistorico {
    codigoProjeto: string;
}

export const TIPO_HISTORICO_PROJETO = 1;
export const TIPO_HISTORICO_DESCONTO = 2;
export const TIPO_HISTORICO_PEDIDO = 3;
export const TIPO_HISTORICO_NOTA_FISCAL = 4;
export const ORIGEM_HISTORICO_V1 = 'V1';
export const ORIGEM_HISTORICO_V2 = 'V2';
export const OPTION_PROJETO: OptionButton = {
    nome: "Projeto",
    id: TIPO_HISTORICO_PROJETO
}
export const OPTION_PEDIDO: OptionButton = {
    nome: "Pedido",
    id: TIPO_HISTORICO_PEDIDO
}
export const OPTION_NOTA_FISCAL: OptionButton = {
    nome: "Nota fiscal",
    id: TIPO_HISTORICO_NOTA_FISCAL
}
export const OPTION_DESCONTO: OptionButton = {
    nome: "Desconto",
    id: TIPO_HISTORICO_DESCONTO
}

export const OPTION_HISTORICO_ANTIGO: OptionButton = {
    nome: "Histórico Antigo",
        id: Number(ORIGEM_HISTORICO_V1?.replace(/\D/g, ''))
}
export const OPTION_HISTORICO_NOVO: OptionButton = {
    nome: "Histórico Novo",
    id: Number(ORIGEM_HISTORICO_V2?.replace(/\D/g, ''))
}

export const TIPOS_HISTORICO_LISTA: OptionButton[] =[
    {
        nome: "Projeto",
        id: TIPO_HISTORICO_PROJETO
    },
    {
        nome: "Desconto",
        id: TIPO_HISTORICO_DESCONTO
    },
    {
        nome: "Pedido",    
        id: TIPO_HISTORICO_PEDIDO
    },
    {
        nome: "Nota fiscal",
        id: TIPO_HISTORICO_NOTA_FISCAL
    },
]

const ORIGEM_HISTORICO_LISTA: OptionButton[] =[
    {
        nome: "Histórico Novo",
        id: Number(ORIGEM_HISTORICO_V2?.replace(/\D/g, ''))
    },
    {
        nome: "Histórico Antigo",
        id: Number(ORIGEM_HISTORICO_V1?.replace(/\D/g, ''))
    },
];

export interface ChangeStatePedido {
    [key: string]: ChangeValidate;
    codigo_venda: ChangeValidate;
}
export interface ChangeState {
    [key: string]: ChangeValidate;
    codigo_venda: ChangeValidate;
    solucao_sugerida: ChangeValidate;
    componentes: ChangeValidate;
    titulo: ChangeValidate;
    distribuidor_id: ChangeValidate;
    revenda_id: ChangeValidate;
    status_projeto: ChangeValidate;
    status_projeto_pagamento: ChangeValidate;
    expirado: ChangeValidate;
    tipo_faturamento: ChangeValidate;
    tipo: ChangeValidate;
    cliente_proposta: ChangeValidate;
    cpf_cnpj_proposta: ChangeValidate;
    email_proposta: ChangeValidate;
    endereco_proposta: ChangeValidate;
    dados_concessionaria_payback: ChangeValidate;
    simultaneidade: ChangeValidate;
    potencia: ChangeValidate;
    preco_kwh: ChangeValidate;
    tipo_proposta: ChangeValidate;
    percentual_comissao_distribuidor: ChangeValidate;
    valor_servico: ChangeValidate;
    valor_margem: ChangeValidate;
    valor_desconto: ChangeValidate;
    valor_servico_pis_cofins: ChangeValidate;
    valor_projeto: ChangeValidate;
    termos_aceite: ChangeValidate;
    codigo_servico: ChangeValidate;
}
  
interface ChangeValidate {
    hasChanged: boolean;
}

const INITIAL_CHANGE_STATE: ChangeState = {
    codigo_venda: {
        hasChanged: false,
    },
    solucao_sugerida: {
        hasChanged: false,
    },
    componentes: {
        hasChanged: false,
    },
    titulo: {
        hasChanged: false,
    },
    distribuidor_id: {
        hasChanged: false,
    },
    revenda_id: {
        hasChanged: false,
    },
    status_projeto: {
        hasChanged: false,
    },
    status_projeto_pagamento: {
        hasChanged: false,
    },
    expirado: {
        hasChanged: false,
    },
    tipo_faturamento: {
        hasChanged: false,
    },
    tipo: {
        hasChanged: false,
    },
    cliente_proposta: {
        hasChanged: false,
    },
    cpf_cnpj_proposta: {
        hasChanged: false,
    },
    email_proposta: {
        hasChanged: false,
    },
    endereco_proposta: {
        hasChanged: false,
    },
    dados_concessionaria_payback: {
        hasChanged: false,
    },
    simultaneidade: {
        hasChanged: false,
    },
    potencia: {
        hasChanged: false,
    },
    preco_kwh: {
        hasChanged: false,
    },
    tipo_proposta: {
        hasChanged: false,
    },
    percentual_comissao_distribuidor: {
        hasChanged: false,
    },
    valor_servico: {
        hasChanged: false,
    },
    valor_margem: {
        hasChanged: false,
    },
    valor_desconto: {
        hasChanged: false,
    },
    valor_servico_pis_cofins: {
        hasChanged: false,
    },
    valor_projeto: {
        hasChanged: false,
    },
    termos_aceite: {
        hasChanged: false,
    },
    codigo_servico: {
        hasChanged: false,
    }
};
const INITIAL_CHANGE_STATE_PEDIDO: ChangeStatePedido = {
    codigo_venda: {
        hasChanged: false,
    }
};

export interface ChangeStateDesconto {
    [key: string]: ChangeValidate;
    valor_intelbras: ChangeValidate;
    justificativa: ChangeValidate;
    desconto_total: ChangeValidate;
    percentual_intelbras: ChangeValidate;
    percentual_revenda: ChangeValidate;
    percentual_distribuidor: ChangeValidate;
}

const INITIAL_CHANGE_STATE_DESCONTO: ChangeStateDesconto = {
    valor_intelbras: {
        hasChanged: false,
    },
    justificativa: {
        hasChanged: false,
    },
    desconto_total: {
        hasChanged: false,
    },
    percentual_intelbras: {
        hasChanged: false,
    },
    percentual_revenda: {
        hasChanged: false,
    },
    percentual_distribuidor: {
        hasChanged: false,
    }
};

export interface ChangeStateNotaFiscal {
    [key: string]: ChangeValidate;
    valor: ChangeValidate;
    numero: ChangeValidate;
    peso_bruto: ChangeValidate;
    itens: ChangeValidate;
    estado: ChangeValidate;
    bairro: ChangeValidate;
    cidade: ChangeValidate;
    complemento: ChangeValidate;
    numero_endereco: ChangeValidate;
    logradouro: ChangeValidate;
    observacao: ChangeValidate;
}

const INITIAL_CHANGE_STATE_NOTA: ChangeStateNotaFiscal = {
    valor: {
        hasChanged: false,
    },
    numero: {
        hasChanged: false,
    },
    peso_bruto: {
        hasChanged: false,
    },
    itens: {
        hasChanged: false,
    },
    estado: {
        hasChanged: false,
    },
    bairro: {
        hasChanged: false,
    },
    cidade: {
        hasChanged: false,
    },
    complemento: {
        hasChanged: false,
    },
    numero_endereco: {
        hasChanged: false,
    },
    logradouro: {
        hasChanged: false,
    },
    observacao: {
        hasChanged: false,
    }
};


const Historico: FC<IHistorico> = ({ codigoProjeto }) => {
    const history = useHistory();

    const ORIGEM_DEFAULT = window.location.pathname?.includes('migrados') 
        ? Number(ORIGEM_HISTORICO_V1?.replace(/\D/g, ''))
        : Number(ORIGEM_HISTORICO_V2?.replace(/\D/g, ''));
    
    const [projeto, setProjeto] = useState<any>(null);
    const [pedido, setPedido] = useState<any>(null);
    const [tipoHistorico, setTipoHistorico] = useState<number>(-1);
    const [optionOrigemHistorico, setOptionOrigemHistorico] = useState<number>(ORIGEM_DEFAULT);
    const [projetoHistoricos, setProjetoHistoricos] = useState<TProjetoHistorico[]>([]);
    const [projetosComparaveis, setProjetosComparaveis] = useState<TProjetoHistorico[]>([]);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [changeState, setChangeState] = useState<ChangeState>(INITIAL_CHANGE_STATE);
    const [pedidosComparaveis, setPedidosComparaveis] = useState<TPedidoHistorico[]>([]);
    const [changeStatePedidos, setChangeStatePedidos] = useState<ChangeStatePedido>(INITIAL_CHANGE_STATE_PEDIDO);
    const [selectedPedidosIds, setSelectedPedidosIds] = useState<number[]>([]);
    const [pedidoHistoricos, setPedidoHistoricos] = useState<TPedidoHistorico[]>([]);
    const componentes = useObservable(componentes$);
    const [descontoHistoricos, setDescontoHistoricos] = useState<any[]>([]);
    const [selectedDescontosIds, setSelectedDescontosIds] = useState<number[]>([]);
    const [descontosComparaveis, setDescontosComparaveis] = useState<any[]>([]);
    const [changeStateDescontos, setChangeStateDescontos] = useState<ChangeStateDesconto>(INITIAL_CHANGE_STATE_DESCONTO);
    const [notaFiscalHistoricos, setNotaFiscalHistoricos] = useState<TNotaHistorico[]>([]);
    const [selectedNotasFiscaisIds, setSelectedNotasFiscaisIds] = useState<number[]>([]);
    const [notasFiscaisComparaveis, setNotasFiscaisComparaveis] = useState<TNotaHistorico[]>([]);
    const [changeStateNotasFiscais, setChangeStateNotasFiscais] = useState<ChangeStateNotaFiscal>(INITIAL_CHANGE_STATE_NOTA);
    const [optionsHistorico, setOptionsHistorico] = useState<OptionButton[]>([]);
    const permissoes = PermissionUtil.getPermissions();
    const [opcoesHistoricoButton, setOpcoesHistoricoButton] = useState<OptionButton[]>([]);

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const getProjeto = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos?codigo_venda=${codigoProjeto}&includes=visita_tecnica_texto,componentes,componentes.atributos,distribuidor,revenda,disposicao,endereco,confirmado_por`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            // TODO: tratar erro
            return;
        }
    
        const projeto = response.data[0] as THistoricoProjeto;
    
        setProjeto(projeto)
    }, [codigoProjeto]);

    const getHistoricoProjeto = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos/historico/${codigoProjeto}`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            notifierStore.setNotifier({
                title: "Atenção!",
                content: response.message,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                    if (response?.message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO)) {
                        window.location.href = `${window.location.origin}/projetos/menu-projetos`
                    }
                }
            });
            notifierStore.setOpen(true); 
            return;
        }
    
        const historicos = response.data as TProjetoHistorico[];
        setProjetoHistoricos(historicos);
    }, [codigoProjeto, tipoHistorico]);

    const getHistoricoProjetoDesconto = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos/historico/desconto/${codigoProjeto}`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            // TODO: tratar erro
            return;
        }

        const historicos = [...response.data];
        //setDescontoAtual(historicos.length === 1 ? historicos?.[0] : historicos?.[historicos.length-1]);
        //setHistoricoDesconto(historicos);
        setDescontoHistoricos(historicos);
    }, [codigoProjeto, tipoHistorico]);

    const getHistoricoPedido = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos/historico/pedido/${codigoProjeto}`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            // TODO: tratar erro
            return;
        }
    
        const historicos = response.data;
        setPedidoHistoricos(historicos)
        //setHistoricoPedido(historicos)
    }, [codigoProjeto, tipoHistorico]);

    const getPedido = useCallback(async () => { 
        const request: IDataRequest = {
            url: `/vendas/pedidos/?codigo_venda=${codigoProjeto}&includes=rastreamentos,termos_aceite,notas_fiscais,notas_fiscais.itens`,
        }
        const response = await api.get(request);

        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            // TODO: tratar erro
            return;
        }

        const pedido = response.data[0];
        setPedido(pedido);

     }, [codigoProjeto, tipoHistorico])

    const getHistoricoNotaFiscal = useCallback(async () => {
        const request: IDataRequest = {
            url: `/projetos/historico/nota_fiscal/${codigoProjeto}`,
        }
        const response = await api.get(request);
    
        if (response.statusCode !== STATUS_CODE.OK && response.statusCode !== STATUS_CODE.NO_CONTENT) {
            // TODO: tratar erro
            return;
        }
    
        const historicos = response.data;
        setNotaFiscalHistoricos(historicos);
    }, [codigoProjeto, tipoHistorico]);

    const getHistoricos = async (_tipoHistorico: number) => {
        if (_tipoHistorico === TIPO_HISTORICO_PROJETO) {
            await getHistoricoProjeto();
        }else if(_tipoHistorico === TIPO_HISTORICO_PEDIDO){
            await getHistoricoPedido();
        }else if(_tipoHistorico === TIPO_HISTORICO_DESCONTO){
            await getHistoricoProjetoDesconto();
        }else if(_tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL){
            await getHistoricoNotaFiscal();
        }
    }
    
    const clickButtonFilter = useCallback(async (categorias: number[], nome: string, categoria: string) => {
        const tipoHistorico = categorias?.[0];
        if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
            await getHistoricos(tipoHistorico);
        }
        
        if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
            await getHistoricoPedido();
            
        }

        if (tipoHistorico === TIPO_HISTORICO_DESCONTO) {
            await getHistoricoProjetoDesconto();
        }

        if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL) {
            await getHistoricoNotaFiscal();
        }

        setTipoHistorico(tipoHistorico);
    }, []);

    const handleChangeHistory = useCallback(async (categorias: number[], nome: string, categoria: string) => {
        const selected = opcoesHistoricoButton.find(_tipo => _tipo.nome === categoria)?.id || 0;
        if (selected === 1) history.push(`/projetos/migrados/listagem/historico/${projeto?.codigo_venda}`);
        if (selected === 2) history.push(`/projetos/listagem/historico/${projeto?.codigo_venda}`);
        setOptionOrigemHistorico(selected);
        if(optionsHistorico?.length){
            setTipoHistorico(optionsHistorico[0]?.id);
        }
    }, [projeto, history]);

    const handleChangeSelected = (historico_id: number) => {
        if (selectedIds.includes(historico_id)){
            delete selectedIds[selectedIds.indexOf(historico_id)]
            const projetos = projetosComparaveis.filter(x=>selectedIds.includes(x.id))
            setProjetosComparaveis(projetos);
        }else{
            setSelectedIds(old => [...selectedIds, historico_id ])
            const projetos = projetosComparaveis.filter(x=>selectedIds.includes(x.id))
            setProjetosComparaveis(projetos);
        }
      };

    const handleChangeSelectedPedido = (historico_id: number) => {
    if (selectedPedidosIds.includes(historico_id)){
        delete selectedPedidosIds[selectedPedidosIds.indexOf(historico_id)]
        const pedidos = pedidosComparaveis.filter(x=>selectedPedidosIds.includes(x.id))
        setPedidosComparaveis(pedidos);
    }else{
        setSelectedPedidosIds(old => [...selectedPedidosIds, historico_id ])
        const pedidos = pedidosComparaveis.filter(x=>selectedPedidosIds.includes(x.id))
        setPedidosComparaveis(pedidos);
    }
    };
    const handleChangeSelectedDesconto = (historico_id: number)=>{
        if (selectedDescontosIds.includes(historico_id)){
            delete selectedDescontosIds[selectedDescontosIds.indexOf(historico_id)]
            const descontos = descontosComparaveis.filter(x=>selectedDescontosIds.includes(x.id))
            setDescontosComparaveis(descontos);
        }else{
            setSelectedDescontosIds(old => [...selectedDescontosIds, historico_id ])
            const descontos = descontosComparaveis.filter(x=>selectedDescontosIds.includes(x.id))
            setDescontosComparaveis(descontos);
        }
    }

    const handleChangeSelectedNotaFiscal = (historico_id: number)=>{
        if (selectedNotasFiscaisIds.includes(historico_id)){
            delete selectedNotasFiscaisIds[selectedNotasFiscaisIds.indexOf(historico_id)]
            const notas = notasFiscaisComparaveis.filter(x=>selectedNotasFiscaisIds.includes(x.id))
            setNotasFiscaisComparaveis(notas);
        }else{
            setSelectedNotasFiscaisIds(old => [...selectedNotasFiscaisIds, historico_id ])
            const notas = notasFiscaisComparaveis.filter(x=>selectedNotasFiscaisIds.includes(x.id))
            setNotasFiscaisComparaveis(notas);
        }
    }

    const handleValorTotal = (historico: any, pedido: any, descontoPedido: boolean) => {
        if (historico?.origem === ORIGEM_HISTORICO_V1 && pedido && descontoPedido) {
            const historicoProjeto = descontoPedido ? (projeto || historico) : historico;
            return Number(((historicoProjeto?.valor || 0) - (historicoProjeto?.valor_desconto || 0) + (historicoProjeto?.valor_servico_pis_cofins || 0) - (pedido?.valor_desconto ? pedido.valor_desconto : 0))) || 0;
        } else {
            return Number(((historico?.valor || 0) - (historico?.valor_desconto || 0) + (historico?.valor_servico_pis_cofins || 0))) || 0;
        }
    }

    const handleValorPedido = (projeto: any, pedido: any) => {
        if (projeto?.origem === ORIGEM_HISTORICO_V1) {
            return Number(((projeto?.valor || 0) - (projeto?.valor_desconto || 0) + (projeto?.valor_servico_pis_cofins || 0) - (pedido?.valor_desconto ? pedido.valor_desconto : 0))) || 0;
        } else {
            return Number((pedido?.valor_pedido || 0) - (pedido?.valor_desconto || 0)) || 0;
        }
    }
    
    const getListaHistorico = () =>  {
        if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
            return projetoHistoricos.map((_historicoProjeto, _index) =>{
                const projetoHistorico = _historicoProjeto?.projeto;
                const ultimoHistorico: boolean = _index === projetoHistoricos?.length -1;
                const descontoPedido: boolean = ultimoHistorico && (((projetoHistorico?.valor_desconto || 0) + (pedido?.valor_desconto || 0)) < (projetoHistorico?.valor || 0));
                return {
                    index: _index,
                    created_at: _historicoProjeto.data_alteracao,
                    usuario: _historicoProjeto?.usuario,
                    valor: handleValorTotal(projetoHistorico, pedido, descontoPedido) || (projetoHistorico?.valor_projeto || 0),
                    historico_id: _historicoProjeto.id,
                }
            })
        }
        
        if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
            const projeto = projetoHistoricos[0]?.projeto;
            return pedidoHistoricos.map((_historicoPedido, _index) => {
                return {
                    index: _index,
                    created_at: _historicoPedido?.data_alteracao,
                    usuario: null,
                    valor: handleValorPedido(projeto, _historicoPedido?.pedido),
                    historico_id: _historicoPedido.id, //momentaneo - só até construir o histórico novo de pedidos
                }
            });
        }
        if (tipoHistorico === TIPO_HISTORICO_DESCONTO){
            return descontoHistoricos.map((_historicoDesconto, _index)=>{
                return {
                    index: _index,
                    created_at: _historicoDesconto?.created_at,
                    usuario: _historicoDesconto?.usuario,
                    historico_id: _historicoDesconto.id,
                }
            })
        }
        if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL){
            return notaFiscalHistoricos.map((_historicoNota, _index)=>{
                return {
                    index: _index,
                    created_at: _historicoNota?.updated_at || _historicoNota?.created_at,
                    historico_id: _historicoNota?.id,
                    valor: _historicoNota.valor,
                }
            })
        }

        return [];
    }
    const fileirasIguais = (fileirasA: any, fileirasB: any)=>{
        //Compara fileiras
        if (fileirasA?.length !== fileirasB?.length) return false;

        const chaves = (obj: any) => ({
            posicao: obj.posicao,
            estrutura_id: obj.estrutura_id,
            fileiras_iguais: obj.fileiras_iguais,
            modulos_sequencia: obj.modulos_sequencia
        });

        const normalize = (arr: any) => arr.map((o: any) => JSON.stringify(chaves(o))).sort();

        const norm1 = normalize(fileirasA);
        const norm2 = normalize(fileirasB);

        return norm1.every((value: any, idx: any) => value === norm2[idx]);
    }
    useEffect(()=>{
        if(permissoes.includes("*")){
            setOptionsHistorico(TIPOS_HISTORICO_LISTA);
        }else{
            const options: OptionButton[]=[]
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes)){
                options.push(OPTION_PROJETO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes)){
                options.push(OPTION_PEDIDO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes)){
                options.push(OPTION_DESCONTO)
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes)){
                options.push(OPTION_NOTA_FISCAL)
            }
            setOptionsHistorico(options);
        }
    },[])

    useEffect(()=>{
        if(permissoes.includes("*")){
            setOpcoesHistoricoButton(ORIGEM_HISTORICO_LISTA);
            //setOptionOrigemHistorico(2);
        }else{
            const options: OptionButton[]=[];
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_ANTIGO, permissoes)){
                options.push(OPTION_HISTORICO_ANTIGO);
                //setOptionOrigemHistorico(1);
            }
            if(PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes)
            || PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes)){
                options.push(OPTION_HISTORICO_NOVO);
                //setOptionOrigemHistorico(2);
            }
            if(!options?.length){
                setTipoHistorico(-1);
            }
            setOpcoesHistoricoButton(options);
        }
    },[handleChangeHistory])
    useEffect(()=>{
        (async ()=>{
            if(optionsHistorico?.length){
                if(tipoHistorico === -1){
                    setTipoHistorico(optionsHistorico[0]?.id || -1)
                }else{
                    setTipoHistorico(tipoHistorico)
                }
                await getHistoricos(optionsHistorico[0]?.id || tipoHistorico);
            }
        })();
    },[optionsHistorico, opcoesHistoricoButton])
    useEffect(() => {
        (async () => {
            await getEstruturasDistribuicao();
            await getCidades();
            await getProjeto();
            await getPedido();
            /*if(optionsHistorico?.length){
                await getHistoricos(optionsHistorico[0]?.id || tipoHistorico);
            }*/
        })();
    }, []);

    useEffect(()=>{
        const projetosComp = projetoHistoricos.filter(x=>selectedIds.includes(x.id))
        setProjetosComparaveis(old => projetosComp);
    },[selectedIds])

    useEffect(()=>{
        const pedidosComp = pedidoHistoricos.filter(x=>selectedPedidosIds.includes(x.id))
        setPedidosComparaveis(old => pedidosComp);
    },[selectedPedidosIds])

    useEffect(()=>{
        const descontosComp = descontoHistoricos.filter(x=>selectedDescontosIds.includes(x.id))
        setDescontosComparaveis(old => descontosComp);
    },[selectedDescontosIds])

    useEffect(()=>{
        const notasComp = notaFiscalHistoricos.filter(x=>selectedNotasFiscaisIds.includes(x.id))
        setNotasFiscaisComparaveis(old => notasComp);
    },[selectedNotasFiscaisIds])

    useEffect(()=>{
        if(projetosComparaveis.length){
            const changes = { ...changeState }            
            for (const field of FIELDS_PROJETO){
                let equal = true;
                switch (field){
                    case "solucao_sugerida":
                        const _projetos = projetosComparaveis;
                        for(let i=0;i<_projetos?.length;i++){
                            if(_projetos[i]?.projeto?.solucao_sugerida){
                                const solucaoAtual = _projetos[i].projeto?.solucao_sugerida?.componentes?.filter((i: any)=>i.quantidade > 0);
                                const primeiraSolucao = _projetos[0].projeto?.solucao_sugerida?.componentes?.filter((i: any)=>i.quantidade > 0);
                                solucaoAtual?.sort((a: any, b: any)=> a.id - b.id);
                                primeiraSolucao?.sort((a: any, b: any)=> a.id - b.id);
                                equal = JSON.stringify(solucaoAtual?.map((c:any)=>{
                                    return {
                                        id: c.id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify(primeiraSolucao?.map((cm:any)=>{
                                    return {
                                        id: cm.id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "componentes":
                        const projetos = projetosComparaveis;

                        for(let i=0;i<projetos?.length;i++){
                            if(projetos[i].projeto?.componentes){
                                projetos[i].projeto?.componentes?.sort((a, b) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((projetos[i].projeto?.componentes)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((projetos[0].projeto?.componentes)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "cpf_cnpj_proposta":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.cpf_cnpj_proposta){

                                equal = (projetosComparaveis[i]?.projeto?.[field] || "") === (projetosComparaveis[0]?.projeto?.[field] || "")
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "termos_aceite":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.termos_aceite){

                                equal = JSON.stringify(projetosComparaveis[i]?.projeto?.[field]) === JSON.stringify(projetosComparaveis[0]?.projeto?.[field])
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.valor){

                                equal = projetosComparaveis[i].projeto?.valor === projetosComparaveis[0].projeto?.valor;
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos_desconto":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.valor){
                                equal = ((projetosComparaveis[i].projeto?.valor || 0) - (projetosComparaveis[i].projeto?.valor_desconto || 0)) === ((projetosComparaveis[0].projeto?.valor || 0) - (projetosComparaveis[0].projeto?.valor_desconto || 0));
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_instalacao":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            equal = projetosComparaveis[i].projeto?.valor_servico === projetosComparaveis[0].projeto?.valor_servico;
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_margem":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            equal = projetosComparaveis[i].projeto?.valor_margem_produtos === projetosComparaveis[0].projeto?.valor_margem_produtos;
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "consumo":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if (projetosComparaveis[i]?.projeto?.origem === ORIGEM_HISTORICO_V1) {
                                const formatValue = arraySort(projetosComparaveis[0]?.projeto?.solucao_sugerida?.consumo, 'dia', 'date')?.map((i:any) => `${moment(i?.dia).format("MM/YYYY")}-${i?.consumo}`);
                                const formatValueAtual = arraySort(projetosComparaveis[i]?.projeto?.solucao_sugerida?.consumo, 'dia', 'date')?.map((i:any) => `${moment(i?.dia).format("MM/YYYY")}-${i?.consumo}`);

                                equal = arrayEquals(formatValue, formatValueAtual);
                            } else {
                                if(projetosComparaveis[i]?.projeto?.solucao_sugerida?.consumo?.length){
                                    equal = JSON.stringify(projetosComparaveis[i]?.projeto?.solucao_sugerida?.consumo) === JSON.stringify(projetosComparaveis[0]?.projeto?.solucao_sugerida?.consumo);
                                    
                                    if(!equal){
                                        break;
                                    }
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "disposicao":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i]?.projeto?.solucao_sugerida?.fileiras){
                                equal = fileirasIguais(projetosComparaveis[i]?.projeto?.solucao_sugerida?.fileiras, projetosComparaveis[0]?.projeto?.solucao_sugerida?.fileiras);
                                
                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "previsao_faturamento":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i]?.projeto?.dados_finalizar){
                                if (projetosComparaveis[i]?.projeto?.dados_finalizar?.data_atual !== projetosComparaveis[0]?.projeto?.dados_finalizar?.data_atual){
                                    equal = false;
                                }else if (projetosComparaveis[i]?.projeto?.dados_finalizar?.data_disponibilidade !== projetosComparaveis[0]?.projeto?.dados_finalizar?.data_disponibilidade){
                                    equal = false;
                                }else if (JSON.stringify(projetosComparaveis[i]?.projeto?.dados_finalizar?.estruturas) !== JSON.stringify(projetosComparaveis[0]?.projeto?.dados_finalizar?.estruturas)){
                                    equal = false;
                                }else if (JSON.stringify(projetosComparaveis[i]?.projeto?.dados_finalizar?.acessorios) !== JSON.stringify(projetosComparaveis[0]?.projeto?.dados_finalizar?.acessorios)){
                                    equal = false;
                                }

                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_proposta":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[0]?.projeto?.valor_servico === 0 && projetosComparaveis[i]?.projeto?.valor_servico !== (projetosComparaveis[0]?.projeto?.valor_servico || 0)){
                                equal = false;
                            }else if(projetosComparaveis[i]?.projeto?.valor_servico === 0 && projetosComparaveis[i]?.projeto?.valor_servico !== (projetosComparaveis[0]?.projeto?.valor_servico || 0)){
                                equal = false;
                            }
                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "revenda":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i]?.projeto?.revenda_id){
                                equal = projetosComparaveis[i]?.projeto?.revenda_id === projetosComparaveis[0]?.projeto?.revenda_id;
                                
                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "distribuidor":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i]?.projeto?.distribuidor_id){
                                equal = projetosComparaveis[i]?.projeto?.distribuidor_id === projetosComparaveis[0]?.projeto?.distribuidor_id;
                                
                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_total":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.valor_projeto){
                                equal = ((projetosComparaveis[i].projeto?.valor_projeto || 0) - (projetosComparaveis[i].projeto?.valor_desconto || 0)) === ((projetosComparaveis[0].projeto?.valor_projeto || 0) - (projetosComparaveis[0].projeto?.valor_desconto || 0));
                                if(!equal){
                                    break;
                                }
                            }else{
                                equal = true;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_servico":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if ((projetosComparaveis[0].projeto?.valor_servico === null && projetosComparaveis[i].projeto?.valor_servico === 0) && (projetosComparaveis[0].projeto?.valor_margem_produtos === null && projetosComparaveis[i].projeto?.valor_margem_produtos === 0)) {
                                equal = true;
                            } else if ((projetosComparaveis[0].projeto?.valor_servico === 0 && projetosComparaveis[i].projeto?.valor_servico === null) && (projetosComparaveis[0].projeto?.valor_margem_produtos === 0 && projetosComparaveis[i].projeto?.valor_margem_produtos === null)) {
                                equal = true;
                            } else if ((projetosComparaveis[0].projeto?.valor_servico === null && projetosComparaveis[i].projeto?.valor_servico === null) && (projetosComparaveis[0].projeto?.valor_margem_produtos === null && projetosComparaveis[i].projeto?.valor_margem_produtos === null)) {
                                equal = true;
                            } else {
                                equal = ((projetosComparaveis[i].projeto?.valor_servico === projetosComparaveis[0].projeto?.valor_servico) && (projetosComparaveis[i].projeto?.valor_margem_produtos === projetosComparaveis[0].projeto?.valor_margem_produtos));
                            }      
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_servico_pis_cofins":
                        for(let i=0;i<projetosComparaveis?.length;i++){                            
                            if(projetosComparaveis[0].projeto?.valor_servico_pis_cofins === null && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === 0){
                                equal = true;
                            }else if (projetosComparaveis[0].projeto?.valor_servico_pis_cofins === 0 && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === null){
                                equal = true;
                            }else if (projetosComparaveis[0].projeto?.valor_servico_pis_cofins === null && projetosComparaveis[i].projeto?.valor_servico_pis_cofins === null){
                                equal = true;
                            }else {
                                equal = projetosComparaveis[i].projeto?.valor_servico_pis_cofins === projetosComparaveis[0].projeto?.valor_servico_pis_cofins;
                            }
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "preco_kwh":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.preco_kwh){
                                equal = projetosComparaveis[i].projeto?.preco_kwh === projetosComparaveis[0].projeto?.preco_kwh;
                                if(!equal){
                                    break;
                                }
                            }else{
                                equal = true;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "simultaneidade":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            equal = Number(projetosComparaveis[i].projeto?.simultaneidade) === Number(projetosComparaveis[0].projeto?.simultaneidade);
                            if(!equal){
                                break;
                            }                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "aceitou_termos":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if (projetosComparaveis[i].projeto?.origem === ORIGEM_HISTORICO_V1) {
                                equal = String(projetosComparaveis[i].projeto?.dados_migracao?.projetoV1?.AceitouOsTermos) === String(projetosComparaveis[0].projeto?.dados_migracao?.projetoV1?.AceitouOsTermos);
                            } else {
                                equal = String (projetosComparaveis[i].projeto?.dados_termo?.aceito_em) === String(projetosComparaveis[0].projeto?.dados_termo?.aceito_em);
                                if(!equal && projetosComparaveis[i].projeto?.dados_termo?.aceito_em && projetosComparaveis[0].projeto?.dados_termo?.aceito_em){
                                    equal = true;
                                }
                            }
                            if(!equal){
                                break;
                            }                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "endereco":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            const enderecoAtual = projetosComparaveis[i].projeto?.endereco;
                            const enderecoPrimeiro = projetosComparaveis[0].projeto?.endereco;
                            if((enderecoAtual?.cidade_id || "") !== (enderecoPrimeiro?.cidade_id || "")){
                                equal = false;
                            }else if((enderecoAtual?.bairro || "") !== (enderecoPrimeiro?.bairro || "")){
                                equal = false;
                            }else if((enderecoAtual?.complemento || "") !== (enderecoPrimeiro?.complemento || "")){
                                equal = false;
                            }else if((enderecoAtual?.cep || "") !== (enderecoPrimeiro?.cep || "")){
                                equal = false;
                            }else if((enderecoAtual?.estado_id || "") !== (enderecoPrimeiro?.estado_id || "")){
                                equal = false;
                            }else if((enderecoAtual?.logradouro || "") !== (enderecoPrimeiro?.logradouro || "")){
                                equal = false;
                            }else if((enderecoAtual?.numero || "") !== (enderecoPrimeiro?.numero || "")){
                                equal = false;
                            }
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tensao":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.inversor_tensao === projetosComparaveis[0].projeto?.solucao_sugerida?.inversor_tensao
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "concessionaria":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.dados_concessionaria_payback){
                                equal = projetosComparaveis[i].projeto?.dados_concessionaria_payback?.agente === projetosComparaveis[0].projeto?.dados_concessionaria_payback?.agente;
                            }
                            if(!equal){
                                break;
                            }                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "fator_perdas":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.fator_perdas === projetosComparaveis[0].projeto?.solucao_sugerida?.fator_perdas
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "nome_modulo":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            //define se é igual
                            if(projetosComparaveis[i]?.projeto?.componentes){
                                const moduloAtual = projetosComparaveis[i]?.projeto?.componentes?.filter((_c: any)=>{
                                    const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                                    return _componenteCache?.categoria_componentes_id === 1;
                                });
                                const primeiroModulo = projetosComparaveis[0]?.projeto?.componentes?.filter((_c: any)=>{
                                    const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                                    return _componenteCache?.categoria_componentes_id === 1;
                                });
                                const sortedPrimeiroModulo = primeiroModulo?.sort((a, b) => a.componente_id - b.componente_id);
                                const sortedModuloAtual = moduloAtual?.sort((a, b) => a.componente_id - b.componente_id);
                                
                                equal = JSON.stringify((sortedPrimeiroModulo)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                    }
                                }))?.toString() === JSON.stringify((sortedModuloAtual)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                    }
                                }))?.toString();
                            }
                            if(!equal){
                                break;
                            }                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "inversor_tipo_conexao":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.inversor_tipo_conexao === projetosComparaveis[0].projeto?.solucao_sugerida?.inversor_tipo_conexao
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_inversor":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if (!!projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor && !!projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor) {
                                equal = projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor === projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor;
                            } else if (projetosComparaveis[i]?.projeto?.tipo === "dimensionado" && projetosComparaveis[0]?.projeto?.tipo === "dimensionado"){                                
                                if(projetosComparaveis[i]?.projeto?.solucao_sugerida){
                                    equal = projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor === projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor;
                                }
                            }else if((projetosComparaveis[0]?.projeto?.tipo === "personalizado" || projeto?.tipo === "kit") && (projetosComparaveis[i]?.projeto?.tipo === "personalizado" || projeto?.tipo === "kit")){
                                if(projetosComparaveis[i]?.projeto?.componentes){
                                    const inversorAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR;
                                    });
            
                                    const microAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_MICROINVERSOR;
                                    });

                                    const hibridoAtual = projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR_HIBRIDO;
                                    });

                                    const offgridAtual = !!projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor
                                        ? inversoresMap[projetosComparaveis[i]?.projeto?.solucao_sugerida?.tipo_inversor]?.value
                                        : projetosComparaveis[i]?.projeto?.componentes?.find((_c: any) => {
                                            const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                            return LISTA_INVERSOR_OFFGRID?.includes(_componenteCache?.categoria_componentes_id);
                                        }); 
    
                                    const inversorPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR;
                                    });
            
                                    const microPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_MICROINVERSOR;
                                    });

                                    const hibridoPrimeiro = projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                        const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                        return _componenteCache?.categoria_componentes_id === ID_INVERSOR_HIBRIDO;
                                    });

                                    const offgridPrimeiro = projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor
                                        ? inversoresMap[projetosComparaveis[0]?.projeto?.solucao_sugerida?.tipo_inversor]?.value
                                        : projetosComparaveis[0]?.projeto?.componentes?.find((_c: any) => {
                                            const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.componente_id);
                                            return LISTA_INVERSOR_OFFGRID?.includes(_componenteCache?.categoria_componentes_id);
                                        });

                                    if (inversorAtual && inversorPrimeiro) {
                                        equal = true;
                                    } else if (microAtual && microPrimeiro) {
                                        equal = true;
                                    } else if (offgridAtual && offgridPrimeiro) {
                                        equal = true;
                                    } else if (hibridoAtual && hibridoPrimeiro) {
                                        equal = true;
                                    } else equal = false;
                                }
                            }
                            if(!equal){
                                break;
                            }                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }

                        break;
                    case "potencia_desejada":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida?.potencia){
                                equal = Number(projetosComparaveis[i].projeto?.solucao_sugerida?.potencia) === Number(projetosComparaveis[0].projeto?.solucao_sugerida?.potencia);
                            }
                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "termos_projeto":
                        for(let i=0;i<projetosComparaveis?.length;i++){                            
                            if (projetosComparaveis[i].projeto?.origem === ORIGEM_HISTORICO_V1) {
                                equal = JSON.stringify(projetosComparaveis[i].projeto?.dados_migracao?.projetoV1?.TextoAceito) === JSON.stringify(projetosComparaveis[0].projeto?.dados_migracao?.projetoV1?.TextoAceito);
                            } else {
                                equal = JSON.stringify(projetosComparaveis[i].projeto?.dados_termo) === JSON.stringify(projetosComparaveis[0].projeto?.dados_termo);
                            }

                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                        case "estabelecimento_id":
                            for(let i=0;i<projetosComparaveis?.length;i++){                            
                                equal = projetosComparaveis[i].projeto?.estabelecimento_id === projetosComparaveis[0].projeto?.estabelecimento_id;
    
                                if(!equal){
                                    break;
                                }
                            }
    
                            if (!equal){
                                changes[field] = {hasChanged: true}
                            }else{
                                changes[field] = {hasChanged: false}
                            }
                            break;
                    case "justificativa_valor_servico":
                        for(let i=0;i<projetosComparaveis?.length;i++){                            
                            equal = projetosComparaveis[i].projeto?.justificativa_valor_servico === projetosComparaveis[0].projeto?.justificativa_valor_servico;

                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_watt_servico":
                        for(let i=0;i<projetosComparaveis?.length;i++){                            
                            equal = projetosComparaveis[i].projeto?.valor_watt_servico === projetosComparaveis[0].projeto?.valor_watt_servico;

                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "equipamentos":
                        const listaProjetos = projetosComparaveis;
                        for (let i=0; i < listaProjetos?.length; i++) {
                            if (listaProjetos[i].projeto?.equipamentos) {
                                listaProjetos[i].projeto?.equipamentos?.sort((a:any, b:any) => a?.id - b.id);
                                const historicoEquipamento = listaProjetos[i].projeto?.equipamentos?.map((equipamento: ProjetosEquipamentosDom)=> ({
                                    id: equipamento?.id,
                                    nome: equipamento?.nome,
                                    potencia: equipamento?.potencia,
                                    horas_uso: equipamento?.horas_uso,
                                    quantidade: equipamento?.quantidade,
                                    consumo_diaria: equipamento?.consumo_diaria
                                }));
                                const primeiroHistorico = listaProjetos[0].projeto?.equipamentos?.map((equipamento: ProjetosEquipamentosDom)=> ({
                                    id: equipamento?.id,
                                    nome: equipamento?.nome,
                                    potencia: equipamento?.potencia,
                                    horas_uso: equipamento?.horas_uso,
                                    quantidade: equipamento?.quantidade,
                                    consumo_diaria: equipamento?.consumo_diaria
                                }));

                                equal = JSON.stringify(historicoEquipamento)?.toString() === JSON.stringify(primeiroHistorico)?.toString();

                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = { hasChanged: true };
                        } else {
                            changes[field] = { hasChanged: false };
                        }
                        break;
                    case "total_consumo_diario_w":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.total_consumo_diario_w === projetosComparaveis[0].projeto?.solucao_sugerida?.total_consumo_diario_w
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "fator_demanda":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.fator_demanda === projetosComparaveis[0].projeto?.solucao_sugerida?.fator_demanda
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_bateria":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.tipo_bateria === projetosComparaveis[0].projeto?.solucao_sugerida?.tipo_bateria
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "autonomia_banco_baterias":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.autonomia_banco_baterias === projetosComparaveis[0].projeto?.solucao_sugerida?.autonomia_banco_baterias
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tensao_saida":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.tensao_saida === projetosComparaveis[0].projeto?.solucao_sugerida?.tensao_saida
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "sugestao_instalacao":
                        for(let i=0;i<projetosComparaveis?.length;i++){ 
                            const primerioAtual = projetosComparaveis[0].projeto;
                            const historicoAtual = projetosComparaveis[i].projeto;
                            equal = historicoAtual?.sugestao_instalacao?.user_id === primerioAtual?.sugestao_instalacao?.user_id &&
                                    JSON.stringify(historicoAtual?.sugestao_instalacao?.texto) === JSON.stringify(primerioAtual?.sugestao_instalacao?.texto);

                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "sugestao_instalacao_alerta":
                        for(let i=0;i<projetosComparaveis?.length;i++){ 
                            const primerioAtual = projetosComparaveis[0].projeto;
                            const historicoAtual = projetosComparaveis[i].projeto;
                            equal = JSON.stringify(historicoAtual?.sugestao_instalacao?.alterta) === JSON.stringify(primerioAtual?.sugestao_instalacao?.alterta);

                            if(!equal){
                                break;
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;

                    case "cargas_prioritarias":
                        const listProjetos = projetosComparaveis;
                        for (let i=0; i < listProjetos?.length; i++) {
                            if (listProjetos[i].projeto?.cargas_prioritarias) {
                                listProjetos[i].projeto?.cargas_prioritarias?.sort((a:any, b:any) => a?.id - b.id);
                                const historicoCargasPrioritarias = listProjetos[i].projeto?.cargas_prioritarias?.map((item: CargasPrioritariasDom)=> ({
                                    id: item?.id,
                                    nome: item?.nome,
                                    potencia: item?.potencia,
                                    horas_uso: item?.horas_uso,
                                    quantidade: item?.quantidade,
                                    consumo_diaria: item?.consumo_diaria,
                                    fator_potencia: item?.fator_potencia,
                                    relacao_partida: item?.relacao_partida,
                                }));
                                const primeiroHistorico = listProjetos[0].projeto?.cargas_prioritarias?.map((item: CargasPrioritariasDom)=> ({
                                    id: item?.id,
                                    nome: item?.nome,
                                    potencia: item?.potencia,
                                    horas_uso: item?.horas_uso,
                                    quantidade: item?.quantidade,
                                    consumo_diaria: item?.consumo_diaria,
                                    fator_potencia: item?.fator_potencia,
                                    relacao_partida: item?.relacao_partida,
                                }));

                                equal = JSON.stringify(historicoCargasPrioritarias)?.toString() === JSON.stringify(primeiroHistorico)?.toString();

                                if (!equal) {
                                    break;
                                }
                            }
                        }

                        if (!equal) {
                            changes[field] = { hasChanged: true };
                        } else {
                            changes[field] = { hasChanged: false };
                        }
                        break;
                    case "total_carga_equipamentos_kw":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.total_carga_equipamentos_kw === projetosComparaveis[0].projeto?.solucao_sugerida?.total_carga_equipamentos_kw
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "taxa_descarga":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.taxa_descarga === projetosComparaveis[0].projeto?.solucao_sugerida?.taxa_descarga
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "tipo_solucao":
                        for(let i=0;i<projetosComparaveis?.length;i++){
                            if(projetosComparaveis[i].projeto?.solucao_sugerida){
                                equal = projetosComparaveis[i].projeto?.solucao_sugerida?.tipo_solucao === projetosComparaveis[0].projeto?.solucao_sugerida?.tipo_solucao
                            }
                            if(!equal){
                                break;
                            }
                            
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    default:
                        equal = projetosComparaveis.every(
                            (obj: TProjetoHistorico) => obj?.projeto?.[field] === projetosComparaveis[0]?.projeto?.[field]
                        );      
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeState({ ...changes })
        }
    },[projetosComparaveis])

    useEffect(()=>{
        if(pedidosComparaveis.length){
            const changes = { ...changeStatePedidos }            
            for (const field of FIELDS_PEDIDOS){
                let equal = true;
                switch (field){
                    case "pedido_erp":
                        for(let i=0;i<pedidosComparaveis?.length;i++){
                            if(pedidosComparaveis[i].pedido?.pedido_erp){

                                equal = pedidosComparaveis[i].pedido?.pedido_erp === pedidosComparaveis[0].pedido?.pedido_erp;
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_total":
                        for(let i=0;i<pedidosComparaveis?.length;i++){
                            if(pedidosComparaveis[i].pedido?.valor_pedido){

                                equal = (pedidosComparaveis[i].pedido?.valor_pedido || 0) - (pedidosComparaveis[i].pedido?.valor_desconto || 0) === (pedidosComparaveis[0].pedido?.valor_pedido || 0) - (pedidosComparaveis[0].pedido?.valor_desconto || 0)
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "nome_transportadora":
                        for(let i=0;i<pedidosComparaveis?.length;i++){
                            if(pedidosComparaveis[i].pedido?.nome_transportadora){

                                equal = pedidosComparaveis[i].pedido?.nome_transportadora === pedidosComparaveis[0].pedido?.nome_transportadora;
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "transportadora":
                        for(let i=0;i<pedidosComparaveis?.length;i++){
                            if(pedidosComparaveis[i].pedido?.transportadora){

                                equal = pedidosComparaveis[i].pedido?.transportadora === pedidosComparaveis[0].pedido?.transportadora;
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "itens":
                        const pedidos = pedidosComparaveis;

                        for(let i=0;i<pedidos?.length;i++){
                            if(pedidos[i]?.pedido?.componentes){
                                pedidos[i]?.pedido?.componentes?.sort((a, b) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((pedidos[i].pedido?.componentes)?.map(c=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((pedidos[0].pedido?.componentes)?.map(cm=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if(!equal){
                                    break;
                                }
                            }
                            if(pedidos[i]?.pedido?.notas_fiscais?.itens){
                                pedidos[i]?.pedido?.nota_fiscal?.itens?.sort((a: any, b: any) => a.componente_id - b.componente_id)
                                equal = JSON.stringify((pedidos[i].pedido?.notas_fiscais?.itens)?.map((c:any)=>{
                                    return {
                                        id: c.componente_id,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((pedidos[0]?.pedido?.notas_fiscais?.itens)?.map((cm: any)=>{
                                    return {
                                        id: cm.componente_id,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_produtos":
                        for(let i=0;i<pedidosComparaveis?.length;i++){
                            if(pedidosComparaveis[i].pedido?.valor){

                                equal = pedidosComparaveis[i].pedido?.valor === pedidosComparaveis[0].pedido?.valor;
    
                                if(!equal){
                                    break;
                                }
                            }
                        }

                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;                    
                    default:
                        equal = pedidosComparaveis.every(
                            (obj: TPedidoHistorico) => obj?.pedido?.[field] === pedidosComparaveis[0]?.pedido?.[field]
                        );         
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeStatePedidos({ ...changes })
        }
    }, [pedidosComparaveis])

    useEffect(()=>{
        if(descontosComparaveis?.length){
            const changes = { ...changeStateDescontos }            
            for (const field of FIELDS_DESCONTOS){
                let equal = true;
                switch (field){
                    case "percentual_distribuidor":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.percentual_distribuidor === descontosComparaveis[0]?.percentual_distribuidor;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "percentual_revenda":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.percentual_revenda === descontosComparaveis[0]?.percentual_revenda;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "percentual_intelbras":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.percentual_intelbras === descontosComparaveis[0]?.percentual_intelbras;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "valor_intelbras":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.valor_intelbras === descontosComparaveis[0]?.valor_intelbras;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "justificativa":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.justificativa === descontosComparaveis[0]?.justificativa;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "desconto_total":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.desconto_total === descontosComparaveis[0]?.desconto_total;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "usuario":
                        for(let i=0;i<descontosComparaveis?.length;i++){    
                            equal = descontosComparaveis[i]?.usuario === descontosComparaveis[0]?.usuario;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                }
            }
            setChangeStateDescontos({ ...changes })
        }
    },[descontosComparaveis])

    useEffect(()=>{
        if(notasFiscaisComparaveis?.length){
            const changes = { ...changeStateNotasFiscais }
            for (const field of FIELDS_NOTAS){
                let equal = true;
                switch (field){
                    case "valor":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.valor === notasFiscaisComparaveis[0]?.valor;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "numero":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.numero === notasFiscaisComparaveis[0]?.numero;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "peso_bruto":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.peso_bruto === notasFiscaisComparaveis[0]?.peso_bruto;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "estado":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.estado === notasFiscaisComparaveis[0]?.estado;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "bairro":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.bairro === notasFiscaisComparaveis[0]?.bairro;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "cidade":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.cidade === notasFiscaisComparaveis[0]?.cidade;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "complemento":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.complemento === notasFiscaisComparaveis[0]?.complemento;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "numero_endereco":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.numero_endereco === notasFiscaisComparaveis[0]?.numero_endereco;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "itens":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){
                            if(notasFiscaisComparaveis[i]?.itens){
                                notasFiscaisComparaveis[i]?.itens?.sort((a: any, b: any) => Number(a.codigo) - Number(b.codigo));
                                equal = JSON.stringify((notasFiscaisComparaveis[i]?.itens)?.map(c=>{
                                    return {
                                        id: c.codigo,
                                        quantidade: c.quantidade
                                    }
                                }))?.toString() === JSON.stringify((notasFiscaisComparaveis[0]?.itens)?.map(cm=>{
                                    return {
                                        id: cm.codigo,
                                        quantidade: cm.quantidade
                                    }
                                }))?.toString();
    
                                if(!equal){
                                    break;
                                }
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "logradouro":
                        for(let i=0;i<notasFiscaisComparaveis?.length;i++){    
                            equal = notasFiscaisComparaveis[i]?.numero_endereco === notasFiscaisComparaveis[0]?.numero_endereco;

                            if(!equal){
                                break;
                            }
                        }
                        if (!equal){
                            changes[field] = {hasChanged: true}
                        }else{
                            changes[field] = {hasChanged: false}
                        }
                        break;
                    case "observacao":                        
                        changes[field] = {hasChanged: false}                        
                        break;
                }
            }
            setChangeStateNotasFiscais({ ...changes })
        }
    },[notasFiscaisComparaveis])
 

    return <div className="Historico">
        <div className="row" style={isMobile ? { marginTop: 20 } : {}}>
            <div className="X12" style={{ display: "flex", marginBottom: 15, marginTop: 15 }}>
                <FlatButton
                    text="Voltar"
                    onClick={() => history.replace('/projetos/menu-projetos')}
                    variant="outlined"
                />
            </div>
            <div className="X12" style={{display: "flex"}}>
                <Typography variant="h6" style={{ fontWeight: "bold", textAlign: "left"}}>
                Projeto - {projeto?.codigo_venda}
                </Typography>
            </div>
        </div>
        <div className="row">

            <div className="X12 S6" style={{display: "flex"}}>
                {/*<FilterButton 
                    nome={TIPOS_HISTORICO_LISTA.find(_tipo => _tipo.id === tipoHistorico)?.nome || ""} 
                    options={TIPOS_HISTORICO_LISTA} 
                    handleClickButton={clickButtonFilter}
                    containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                />*/}
                {optionsHistorico?.length > 0 && (
                    <FilterButton 
                        nome={optionsHistorico.find(_tipo => _tipo.id === tipoHistorico)?.nome || ""} 
                        options={optionsHistorico} 
                        handleClickButton={clickButtonFilter}
                        containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                    />)
                }

                { (projeto?.origem === ORIGEM_HISTORICO_V1 && PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_ANTIGO, permissoes)) && (
                    <FilterButton
                        nome={opcoesHistoricoButton.find(_tipo => _tipo.id === optionOrigemHistorico)?.nome || ""} 
                        options={opcoesHistoricoButton} 
                        handleClickButton={handleChangeHistory}
                        containerStyles={{alignContent: "flex-start", width: 'auto', marginRight: 30}}
                    />
                )}
            </div>
        </div>
        <div className="row">
            <div className="X12"  style={{display: "flex", overflowX: "auto", flexDirection: "row" }}>
                {getListaHistorico()?.map((_historico, index, projeto_id) => {
                    return <div>
                        {[TIPO_HISTORICO_PROJETO, TIPO_HISTORICO_PEDIDO, TIPO_HISTORICO_DESCONTO, TIPO_HISTORICO_NOTA_FISCAL].includes(tipoHistorico) &&
                            <CardHistoricoNovo
                                selecionado={selectedIds.includes(_historico.historico_id) || selectedPedidosIds.includes(_historico.historico_id) || selectedDescontosIds.includes(_historico.historico_id) || selectedNotasFiscaisIds.includes(_historico.historico_id)}
                                key={index}
                                historico={_historico}
                                tipoHistorico={tipoHistorico}
                                onClick={() => {
                                    if (tipoHistorico === TIPO_HISTORICO_PROJETO) {
                                        handleChangeSelected(projeto_id[index].historico_id);
                                    }else if (tipoHistorico === TIPO_HISTORICO_PEDIDO) {
                                        handleChangeSelectedPedido(projeto_id[index].historico_id)
                                    }else if (tipoHistorico === TIPO_HISTORICO_DESCONTO){
                                        handleChangeSelectedDesconto(projeto_id[index].historico_id)
                                    }else if (tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL){
                                        handleChangeSelectedNotaFiscal(projeto_id[index].historico_id)
                                    }
                                }}
                            />}
                    </div> 
                })}
                {getListaHistorico().length === 0 && <>
                    <div className="X12">
                        <h3>Nenhum histórico encontrado</h3>
                    </div>
                </>}
            </div>
        </div>
        {tipoHistorico === TIPO_HISTORICO_PROJETO && projetosComparaveis?.length > 0 && PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PROJETOS, permissoes) &&(
            <TabelaComparacaoProjetos dados={projetosComparaveis} pedido={pedido} projeto={projeto} changeState={changeState}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_PEDIDO && pedidosComparaveis?.length > 0 && PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_PEDIDOS, permissoes) &&(
            <TabelaComparacaoPedidos dados={pedidosComparaveis} projeto={projeto} changeState={changeStatePedidos}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_DESCONTO && descontosComparaveis?.length > 0 && PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_DESCONTOS, permissoes) &&(
            <TabelaComparacaoDescontos dados={descontosComparaveis} changeState={changeStateDescontos}/>
        )}
        {tipoHistorico === TIPO_HISTORICO_NOTA_FISCAL && notasFiscaisComparaveis?.length > 0 && PermissionUtil.can(PermissionUtil.PERMISSION_HISTORICO_NOTAS_FISCAIS, permissoes) &&(
            <TabelaComparacaoNotasFiscais dados={notasFiscaisComparaveis} changeState={changeStateNotasFiscais}/>
        )}
    </div>
}

export { Historico };